import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/static/css/main.scss';
import { VuelidatePlugin } from '@vuelidate/core';
import dayjs from 'dayjs';
import lodash from 'lodash';
import i18n from '@/i18n';
import '@/common/utils/nativeCall';
import ServiceExec from '@/common/utils/ServiceExec';
import CommonSvc from '@/common/service/CommonSvc';
import { extendConsole } from '@/common/utils/Override';

extendConsole();
/** swiper **/
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import VueScrollTo from 'vue-scrollto';

import { ObserveVisibility } from 'vue-observe-visibility';
import observeVisibility from 'vue-observe-visibility/src/directives/observe-visibility';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
/** swiper **/
const app = createApp(App);

//preventWarn
app.config.warnHandler = (msg, instance, trace) => {};

app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$_ = lodash;
app.config.globalProperties.$CommonSvc = CommonSvc;
app.config.globalProperties.$ServiceExec = ServiceExec;
app.config.globalProperties.$router = router;

app.component(Swiper.name, Swiper);
app.component(SwiperSlide.name, SwiperSlide);

app.directive('observe-visibility', ObserveVisibility);

app.directive('show-modal-alert', {
  mounted: (el) => {
    setTimeout(() => {
      el.classList.add('on');
    }, 20);
  },
  beforeUnmount: (el) => {
    setTimeout(() => {
      el.classList.remove('on');
    }, 20);
  }
});

app.directive('show-modal', {
  mounted: (el) => {
    setTimeout(() => {
      el.classList.remove('off');
    }, 20);
  },
  beforeUnmount: (el) => {
    setTimeout(() => {
      el.classList.add('off');
    }, 20);
  }
});

export const vueI18n = i18n;

app
  .use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  })
  .use(store)
  .use(router)
  .use(VuelidatePlugin)
  .use(i18n)
  .mount('#app');
